var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1771549903964,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 62849,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421 167.2v689.6H248.9V487.1c0-53.4-1.3-85.5-3.8-96.3-2.6-10.8-9.6-19-21.1-24.5s-37.1-8.3-76.9-8.3h-17v-80.4c83.2-17.9 146.4-54.7 189.6-110.4H421zM894 400.7v230c0 52.3-2.8 90.3-8.5 114.2-5.7 23.9-17.5 46.1-35.4 66.9-17.9 20.7-39.5 35.6-64.8 44.7s-53.5 13.6-84.8 13.6c-41.2 0-75.4-4.8-102.7-14.3-27.3-9.5-49-24.3-65.2-44.5-16.2-20.2-27.7-41.4-34.5-63.7-6.8-22.3-10.2-57.7-10.2-106.3V400.7c0-63.3 5.5-110.7 16.4-142.3 10.9-31.5 32.7-56.8 65.2-75.8s71.9-28.5 118.2-28.5c37.8 0 71.6 6.6 101.4 19.8s52.1 29.3 66.9 48.3 24.8 40.5 30 64.3c5.4 23.9 8 61.9 8 114.2z m-172.1-58c0-36.6-1.8-59.6-5.3-68.8-3.6-9.2-11.9-13.8-24.9-13.8-12.8 0-21.2 4.9-25.4 14.7-4.1 9.8-6.2 32.4-6.2 67.9v336.5c0 40 1.9 64.2 5.8 72.4 3.8 8.2 12.1 12.4 24.9 12.4s21.2-4.8 25.1-14.5c4-9.7 6-31.4 6-65.2V342.7z",
    "p-id": 62850,
    fill: "#FFBB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFive);
export default __webpack_public_path__ + "static/media/five.3f2efe83.svg";
export { ForwardRef as ReactComponent };